import * as React from 'react';

import { Box, Button, DateRangePicker, Spacer, Typography } from '@seeneco-ui/core';

type LeadsHeaderProps = {
	dateRange: DateRange;
	isFetching: boolean;
	isFetchingNewLeadSmsText: boolean;
	onAddLead: () => void;
	onRequestUpdateLeads: () => void;
	onSetDateRange: (dateRange: DateRange) => void;
};

const LeadsHeader: React.SFC<LeadsHeaderProps> = props => {
	const { dateRange, isFetching, isFetchingNewLeadSmsText, onAddLead, onRequestUpdateLeads, onSetDateRange } = props;

	const handleSetDateRange = (dateStart: string, dateEnd: string) => onSetDateRange({ dateStart, dateEnd });

	return (
		<Box alignItems='center' display='flex' justifyContent='space-between' width='100%'>
			<Box alignItems='center' display='flex' justifyContent='space-between' marginRight='30px'>
				<Typography.Title marginRight='10px' textTransform='none'>
					Список заявок за
				</Typography.Title>
				<DateRangePicker
					appearance='title'
					dateEnd={dateRange.dateEnd}
					dateStart={dateRange.dateStart}
					disabled={isFetching}
					onChange={handleSetDateRange}
				/>
			</Box>
			<Box display='flex'>
				<Button appearance='outlined' color='primary' onClick={onRequestUpdateLeads}>
					Обновить список
				</Button>
				<Spacer size={20} />
				<Button appearance='contained' color='primary' disabled={isFetchingNewLeadSmsText} onClick={onAddLead}>
					Добавить лид
				</Button>
			</Box>
		</Box>
	);
};

LeadsHeader.defaultProps = {};
LeadsHeader.displayName = 'LeadsHeader';

export { LeadsHeader, LeadsHeaderProps };
